import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "href", "linkMode", "onClick", "tabIndex", "use"];
import { Link } from 'foundations-components/transitional/components/Link';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
export function PolymorphicLink(_ref) {
  let {
      children,
      href,
      linkMode,
      onClick,
      tabIndex,
      use
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (linkMode === 'react-router' && href) {
    return /*#__PURE__*/_jsx(RouterLink, Object.assign({
      onClick: onClick,
      tabIndex: tabIndex,
      to: href,
      use: use
    }, props, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(Link, Object.assign({
    href: href,
    onClick: onClick,
    rel: linkMode === 'external' ? 'noopener noreferrer' : undefined,
    tabIndex: tabIndex,
    target: linkMode === 'external' ? '_blank' : undefined,
    use: use
  }, props, {
    children: children
  }));
}